import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFadeIn24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconFadeIn24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M13.023 1.34a1 1 0 0 1 .246.035c5.333.604 9.478 5.128 9.478 10.623l-.014.55c-.265 5.235-4.296 9.472-9.438 10.067a.9.9 0 0 1-1.172-.858V2.24a.9.9 0 0 1 .9-.9m-3.627.525a.9.9 0 0 1 .9.9v18.464a.901.901 0 0 1-1.8.001V2.766a.9.9 0 0 1 .9-.9m4.528 18.824c4.013-.86 7.023-4.422 7.023-8.691s-3.01-7.835-7.023-8.694zM5.777 3.79a.9.9 0 0 1 .9.9v14.62a.9.9 0 0 1-1.8 0V4.688a.9.9 0 0 1 .9-.9M2.154 7.051a.9.9 0 0 1 .9.9v8.091a.9.9 0 0 1-1.8 0v-8.09a.9.9 0 0 1 .9-.901"
            />
        </svg>
    );
}
export default memo(IconFadeIn24);
